import React from 'react';

import { FieldElementPropTypes } from '../propTypes';
import AddressAutocomplete from 'core/components/address-autocomplete';

const AddressField = ({ field: fieldProps }) => {
  return <AddressAutocomplete {...fieldProps} />;
};

AddressField.propTypes = FieldElementPropTypes;

export default AddressField;
